import { readHalmParametersQueryString } from "../../shared/pdp/utils/halmParameters";

const PREVIOUS_BUNDLE_PRODUCT_ID_PARAMETER = "previous_bundle_product_id";

export const readPersonalizedFertilizerQueryString = () => {
  const params = new URLSearchParams(readHalmParametersQueryString());
  const previousBundleProductId = new URLSearchParams(
    window.location.search,
  ).get(PREVIOUS_BUNDLE_PRODUCT_ID_PARAMETER);

  if (previousBundleProductId) {
    params.set(PREVIOUS_BUNDLE_PRODUCT_ID_PARAMETER, previousBundleProductId);
  }

  return params.toString();
};
